import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from './shared';

const EmergencyFundCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [monthlyExpenses, setMonthlyExpenses] = useState('3.000,00');
  const [months, setMonths] = useState('6');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const e = parseFloat(parseBrazilianNumber(monthlyExpenses)) || 0;
    const m = parseInt(months) || 0;
    if (e <= 0 || m <= 0) return;

    const total = e * m;
    const res = { total, e, m };
    setResultState(res);
    onResultChange([
      { label: 'Gastos Mensais', value: `R$ ${e.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Meses de Reserva', value: m.toString() },
      { label: 'Total Reserva', value: `R$ ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Gastos Mensais (R$)" value={monthlyExpenses} onChange={setMonthlyExpenses} required isNumeric type="text" />
          <FormField label="Meses de Reserva" value={months} onChange={setMonths} required isInteger type="text" step="1" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Reserva
          </button>
        </div>

        {resultState && (
          <ResultCard title="Reserva Necessária" value={`R$ ${resultState.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} description={`Cobre ${resultState.m} meses de despesas`} color="indigo" />
        )}
      </div>

      <EducationalBlock
        title="O que é a Reserva de Emergência?"
        tips={[
          'A reserva serve para imprevistos (saúde, demissão, reparos urgentes)',
          'Recomendado: 3 a 6 meses para CLT, 6 a 12 meses para autônomos',
          'O valor deve estar em um investimento de alta liquidez (resgate imediato)',
          'Considere apenas os gastos essenciais para sobreviver em caso de crise'
        ]}
      />
    </div>
  );
};

export default EmergencyFundCalculator;
